import axios from 'axios';
import { EncoderScriptTemplates } from '@mimir/client-common/model/encoderExporterTypes';
import escapeRegExp from 'lodash/escapeRegExp';
import type { ElectronContext } from '@mimir/common/context/applicationContext';

let dvrExporterScriptString = '';
const getDvrExporterScriptString = async () => {
  if (dvrExporterScriptString) {
    return dvrExporterScriptString;
  }

  const siteRoot = window.location.origin;
  const timestamp = new Date().getTime();
  console.debug(`siteRoot: ${siteRoot}`);

  const dvrExporterResponse = await axios.get(`${siteRoot}/assets/dvrExporter.py?ts=${timestamp}`);
  dvrExporterScriptString = dvrExporterResponse.data;

  return dvrExporterScriptString;
};

/**
 * We need to add extra escape characters to path strings being used in the DVR script string for Windows.
 */
function getPathForScript(electronContext: ElectronContext, pathForScript: string) {
  let result = pathForScript;
  if (result && electronContext.isWindows) {
    result = result.replace(/\\/g, '\\\\');
    result = result.replace(/\//g, '\\\\');
  }

  return result;
}

/**
 * Builds a custom Python script for the given params and returns the string so that it can be written as a
 * disk file to be pointed to from the DVR launch command. The script starts the encoding for the given
 * .drp source file, and writes progress/error/completion info to a disk file.
 */
export const getScriptString = async (applicationContext: ElectronContext, encoderExePath: string, itemId: string, projectPath: string, presetPath: string, outputPath: string, progressFilePath: string) => {
  // Construct the DVR script that launches the render job and writes progress to disk by first fetching the
  // static script code and then replacing the placeholders for dynamic variables with their actual value
  let exporterScript = await getDvrExporterScriptString();
  const replacements = {
    [EncoderScriptTemplates.SCRIPT_SOURCE_PATH_TEMPLATE]: getPathForScript(applicationContext, projectPath),
    [EncoderScriptTemplates.SCRIPT_PRESET_PATH_TEMPLATE]: getPathForScript(applicationContext, presetPath),
    [EncoderScriptTemplates.SCRIPT_DESTINATION_PATH_TEMPLATE]: getPathForScript(applicationContext, outputPath),
    [EncoderScriptTemplates.SCRIPT_PROGRESS_PATH_TEMPLATE]: getPathForScript(applicationContext, progressFilePath),
    [EncoderScriptTemplates.ENCODER_EXE_PATH_TEMPLATE]: getPathForScript(applicationContext, encoderExePath),
    [EncoderScriptTemplates.ITEM_ID_TEMPLATE]: itemId,
  };
  const replacementPattern = new RegExp(
    Object.keys(replacements)
      .map(key => escapeRegExp(key))
      .join('|'),
    'g'
  );
  exporterScript = exporterScript.replace(
    replacementPattern,
    (match) => replacements[match as keyof typeof replacements] || ''
  );

  return exporterScript;
};
